export default __webpack_public_path__ + "static/media/HW_4.9a5de047.gif";